var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.547 21.7483C16.3288 21.7483 21.0158 17.0612 21.0158 11.2794C21.0158 5.49761 16.3288 0.810547 10.547 0.810547C4.76519 0.810547 0.078125 5.49761 0.078125 11.2794C0.078125 17.0612 4.76519 21.7483 10.547 21.7483Z",
    fill: "#FBA03D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9241 10.4941L17.9873 25.8765L0.183594 25.8288L9.10506 10.4941H26.9241Z",
    fill: "#0070BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9863 25.8768L0.182602 25.8291L0.175781 27.1506L17.9744 27.1984L17.9863 25.8768Z",
    fill: "#273D79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9214 10.4941L17.9795 25.8782L17.9727 27.198L26.9095 11.8157L26.9214 10.4941Z",
    fill: "#42558B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9455 19.1087L12.3002 18.4932H5.19641L4.84173 19.1087L1.64453 24.6471H8.74828L9.10296 24.0316L11.9455 19.1087ZM8.39361 24.0316H2.70856L5.55108 19.1087H11.2344L8.3919 24.0316H8.39361Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4706 19.1087L20.8253 18.4932H13.7198L13.3652 19.1087L10.5226 24.0316L10.168 24.6471H17.2734L17.6281 24.0316L20.4706 19.1087ZM16.9188 24.0316H11.2354L14.0779 19.1087H19.7613L16.9188 24.0316Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8564 11.1094H9.46203L9.10736 11.7249L6.26483 16.6478L5.91016 17.2633H13.0156L16.5675 11.1094H15.8564ZM9.81671 11.7249H15.5001L12.6575 16.6478H6.97418L9.81671 11.7249Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7363 11.724L25.0909 11.1084H17.9855L17.6308 11.724L14.7883 16.6468L14.4336 17.2624H21.5391L21.8937 16.6468L24.7363 11.724ZM21.1844 16.6468H15.501L18.3436 11.724H24.0269L21.1844 16.6468Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPanel);
export default __webpack_public_path__ + "static/media/solar-panel.64737ae5e73868b317e5c28fed479ab5.svg";
export { ForwardRef as ReactComponent };